// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StartCard_wrapper__9opMi","wrapperList":"StartCard_wrapperList__-6qSH"};